import React, {useCallback, useEffect, useState} from 'react';

export const Curate = () => {
    const [state, setState] = useState();
    const [loading, setLoading] = useState({}); // {factId: 'text'|'image'|'drop'}

    const fetchState = useCallback(() => {
        fetch('/allegedly-true/state', {credentials: 'include'})
            .then(r => r.json())
            .then(setState)
            .catch(() => {});
    }, []);

    useEffect(() => {
        fetchState();
        const interval = setInterval(fetchState, 2000);
        return () => clearInterval(interval);
    }, [fetchState]);

    const act = (factId, kind, path) => {
        setLoading(prev => ({...prev, [factId]: kind}));
        fetch(path, {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
        })
            .then(r => r.json())
            .then(() => fetchState())
            .finally(() => setLoading(prev => {
                const next = {...prev};
                delete next[factId];
                return next;
            }));
    };

    const reset = () => {
        if (!window.confirm('Reset progress? This wipes all votes and rewinds to the start. Facts and images stay.')) return;
        fetch('/allegedly-true/reset', {method: 'POST', credentials: 'include'})
            .then(() => fetchState());
    };

    if (!state) return <div style={{padding: 40, color: 'white'}}>Loading…</div>;

    const factsOnly = state.facts.filter(f => f.display_as !== 'narration');

    return (
        <div style={{padding: 24, color: 'white', minHeight: '100vh'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24}}>
                <div style={{fontSize: 36, fontWeight: 'bold'}}>Curate: Allegedly True</div>
                <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                    <button onClick={reset} style={{
                        border: '1px solid #ff8888',
                        backgroundColor: 'transparent',
                        color: '#ff8888',
                        padding: '8px 14px',
                        fontSize: 16,
                        cursor: 'pointer',
                        borderRadius: 4,
                    }}>Reset progress</button>
                    <div style={{fontSize: 18, opacity: 0.7}}>{factsOnly.length} facts</div>
                </div>
            </div>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 24}}>
                {factsOnly.map(fact => {
                    const status = fact.status;
                    const lk = loading[fact.id];
                    const isProcessing = status === 'processing' || lk;

                    return (
                        <div key={fact.id} style={{
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: 8,
                            padding: 16,
                            backgroundColor: '#111',
                            opacity: isProcessing ? 0.6 : 1,
                            position: 'relative',
                        }}>
                            {fact.image_path ? (
                                <img src={fact.image_path} alt="" style={{
                                    width: '100%', aspectRatio: '1 / 1', objectFit: 'cover',
                                    borderRadius: 4, marginBottom: 12,
                                }}/>
                            ) : (
                                <div style={{
                                    width: '100%', aspectRatio: '1 / 1', backgroundColor: '#222',
                                    borderRadius: 4, marginBottom: 12,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: 14, opacity: 0.6,
                                }}>{status === 'error' ? 'image failed' : 'no image yet'}</div>
                            )}

                            <div style={{
                                display: 'inline-block',
                                padding: '4px 8px',
                                fontSize: 12,
                                fontWeight: 700,
                                borderRadius: 4,
                                marginBottom: 8,
                                backgroundColor: fact.display_as === 'true' ? '#1a5e1a' : '#5e1a1a',
                            }}>
                                Shown as {fact.display_as.toUpperCase()}
                            </div>

                            <div style={{fontSize: 16, marginBottom: 10, lineHeight: 1.4}}>
                                {fact.display_text}
                            </div>

                            {fact.display_as === 'false' && (
                                <details style={{fontSize: 13, opacity: 0.7, marginBottom: 10}}>
                                    <summary style={{cursor: 'pointer'}}>true version</summary>
                                    <div style={{marginTop: 6, fontStyle: 'italic'}}>{fact.true_fact}</div>
                                </details>
                            )}

                            {fact.transition_text && (
                                <div style={{fontSize: 12, opacity: 0.6, marginBottom: 10, fontStyle: 'italic', borderLeft: '2px solid rgba(255,255,255,0.2)', paddingLeft: 8}}>
                                    "{fact.transition_text}"
                                </div>
                            )}

                            <div style={{display: 'flex', gap: 6, flexWrap: 'wrap'}}>
                                {fact.display_as === 'false' && (
                                    <button
                                        disabled={isProcessing}
                                        onClick={() => act(fact.id, 'text', `/allegedly-true/regenerate-text/${fact.id}`)}
                                        style={miniBtn}
                                    >
                                        {lk === 'text' ? '…' : 'Re-roll Text'}
                                    </button>
                                )}
                                <button
                                    disabled={isProcessing}
                                    onClick={() => act(fact.id, 'image', `/allegedly-true/regenerate-image/${fact.id}`)}
                                    style={miniBtn}
                                >
                                    {lk === 'image' ? '…' : 'Re-roll Image'}
                                </button>
                                <button
                                    disabled={isProcessing}
                                    onClick={() => act(fact.id, 'drop', `/allegedly-true/drop/${fact.id}`)}
                                    style={{...miniBtn, color: '#ff8888'}}
                                >
                                    {lk === 'drop' ? '…' : 'Drop'}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const miniBtn = {
    border: '1px solid rgba(255,255,255,0.5)',
    backgroundColor: 'transparent',
    color: 'white',
    padding: '6px 10px',
    fontSize: 13,
    cursor: 'pointer',
    borderRadius: 4,
};

export default Curate;
